<template>
  <div class="container">
    <div class="doc__content">
      <div>
        <h2>1. บททั่วไป</h2>
        <p>
          ข้อกำหนดเหล่านี้เป็นข้อกำหนดการใช้งานและบริการ (“ข้อกำหนด”) ของบริษัท
          คาร์ซัม (ประเทศไทย) จำกัด (เลขทะเบียนนิติบุคคล 0105559096112)
          การเข้าถึงและการใช้บริการบนเว็บไซต์นี้ (“เว็บไซต์”)
          อยู่ภายใต้ข้อกำหนดเหล่านี้
          คาร์ซัมให้บริการแพลตฟอร์มยานยนต์ออนไลน์ซึ่งช่วยให้ผู้ที่จะซื้อสามารถค้นหา
          เปรียบเทียบ ประมูลและซื้อรถยนต์ที่แสดงรายการอยู่บนเว็บไซต์
          ในการเข้าถึงและใช้งานเว็บไซต์
          ท่านตกลงปฏิบัติตามและผูกพันตามข้อกำหนดเหล่านี้ซึ่งจะมีผลกับผู้ใช้เว็บไซต์ทั้งหมด
          หากท่านกำลังใช้และเข้าถึงเว็บไซต์ในนามขององค์กรทางธุรกิจ คำว่า “ท่าน”
          ในข้อกำหนดเหล่านี้จะหมายถึงองค์กรธุรกิจที่ท่านเป็นตัวแทนในการใช้งานเว็บไซต์
          เว้นแต่ในบริบทจะไม่ได้อนุญาตไว้
          ท่านควรอ่านข้อกำหนดเหล่านี้อย่างละเอียดเนื่องจากข้อกำหนดเหล่านี้มีผลต่อสิทธิและความรับผิดของท่านภายใต้กฎหมายและข้อบังคับที่บังคับใช้ในประเทศไทย
          หากท่านไม่ยอมรับข้อกำหนดเหล่านี้ ท่านไม่ควรเข้าใช้งานเว็บไซต์
        </p>
        <h2>2. สิทธิในการใช้และข้อจำกัด</h2>
        <ul>
          <li>
            <p>
              2.1&nbsp;ท่านจะต้องรับผิดชอบต่อการเข้าถึงและการใช้งานเว็บไซต์
              รวมทั้งการได้รับการเข้าถึงเครือข่ายข้อมูลที่จำเป็น
              ถึงแม้ว่าการเข้าถึงนั้นจะดำเนินการโดยบุคคลอื่นก็ตาม
            </p>
          </li>
          <li>
            <p>
              2.2&nbsp;ท่านกำลังเข้าถึงและใช้งานเว็บไซต์ภายใต้ความเสี่ยงของท่านเอง
              เราจะไม่รับผิดชอบต่อความเสียหายใดๆ หรือไวรัสหรือรหัสอื่นๆ
              ที่อาจส่งผลกระทบต่อฮาร์ดแวร์หรืออุปกรณ์ ซอฟต์แวร์ ข้อมูล
              หรือทรัพย์สินใดๆ อันเป็นผลมาจากการเข้าถึงและใช้งานเว็บไซต์ของท่าน
            </p>
          </li>
          <li>
            <p>
              2.3&nbsp;ท่านสามารถเข้าถึงเว็บไซต์โดยวิธีการที่ได้รับอนุญาตเท่านั้น
              ซึ่งถือเป็นความรับผิดชอบของท่านในการตรวจสอบและทำให้แน่ใจว่าท่านได้ดาวน์โหลด
              และ/หรือ
              อัปเดตซอฟต์แวร์ที่ถูกต้องสำหรับฮาร์ดแวร์และอุปกรณ์เพื่อการเข้าถึงและใช้งานเว็บไซต์ของท่าน
              เราไม่รับประกันว่าเว็บไซต์
              หรือส่วนใดส่วนหนึ่งดังกล่าวจะทำงานได้อย่างที่ตั้งใจไว้บนฮาร์ดแวร์หรืออุปกรณ์ใด
              ๆ เราจะไม่รับผิดชอบหากท่านไม่มีฮาร์ดแวร์หรืออุปกรณ์ที่เข้ากันได้
              หรือหากท่านดาวน์โหลดซอฟต์แวร์ผิดเวอร์ชั่นสำหรับฮาร์ดแวร์หรืออุปกรณ์ของท่าน
            </p>
          </li>
          <li>
            <p>
              2.4&nbsp;ท่านจะเข้าถึงและใช้งานเว็บไซต์ตามคำแนะนำในการเข้าถึงและใช้งานเว็บไซต์ซึ่งเราอาจจัดทำขึ้นเป็นครั้งคราว
              โดยให้ข้อกำหนดและข้อบังคับเหล่านี้มีผลบังคับใช้ในประเทศไทยในเวลานั้น
            </p>
          </li>
          <li>
            <p>2.5&nbsp;ท่านจะไม่</p>
            <ul>
              <li>
                <p>
                  (a) แอบอ้างเป็นบุคคลหรือฝ่ายใดๆ หรือแสดงความเท็จ บิดเบือน
                  หรือหลอกลวงในเรื่องความเกี่ยวพันของท่านกับบุคคลหรือฝ่ายใดๆ
                  ที่เกี่ยวข้องกับเว็บไซต์ หรือแสดงออก
                  หรือบอกเป็นนัยว่าเราได้รับรองข้อความใดๆ ที่ท่านทำขึ้น
                </p>
              </li>
              <li>
                <p>
                  (b) ทำให้เกิดความเสียหาย หรือขัดขวางเว็บไซต์ และ/หรือ
                  การดำเนินการของเว็บไซต์ไม่ว่าในทางใด;
                </p>
              </li>
              <li>
                <p>
                  (c) ใช้เว็บไซต์ในการฉ้อโกง
                  หรือใช้เพื่อวัตถุประสงค์ที่ไม่ได้รับอนุญาตหรือผิดกฎหมาย;
                </p>
              </li>
              <li>
                <p>
                  (d) ให้ข้อมูลหรือเนื้อหาที่เป็นเท็จ ทำให้เข้าใจผิด ไม่ถูกต้อง
                  ผิดกฎหมาย ข่มขู่ อนาจาร มีเจตนาร้าย
                  ใส่ร้ายหรือหมิ่นประมาทโดยจงใจและรับรู้
                </p>
              </li>
              <li>
                <p>
                  (e) ใช้เว็บไซต์ในลักษณะที่อาจขัดต่อผลประโยชน์ของเรา และ/หรือ
                  ผลประโยชน์ของผู้ใช้รายอื่น;
                </p>
              </li>
              <li>
                <p>
                  (f) นำเข้าหรือยินยอมให้มีการนำเข้าไวรัสคอมพิวเตอร์ และ/หรือ
                  ชุดคำสั่งโปรแกรมคอมพิวเตอร์อื่นๆ เช่น ไวรัส (viruses) มัลแวร์
                  (malware) อีเมลที่ไม่พึงประสงค์ (unsolicited e-mails)
                  ม้าโทรจัน (trojan horses) ประตูกับดัก (trap doors) ประตูหลัง
                  (back doors) หนอนคอมพิวเตอร์ (worms) ระเบิดเวลา (time bombs)
                  หรือไวรัสลบข้อมูล (cancelbots) ที่อาจสร้างความเสียหาย
                  เป็นอันตราย
                  ลักลอบขัดขวางหรือยึดเอาระบบข้อมูลหรือข้อมูลส่วนบุคคลใดๆ
                  ที่เกี่ยวข้องหรือเกี่ยวกับเว็บไซต์;
                </p>
              </li>
              <li>
                <p>
                  (g) ทำซ้ำ ทำสำเนา คัดลอก ขาย ขายต่อ
                  หรือใช้ประโยชน์ในทางอื่นเพื่อวัตถุประสงค์ทางการค้า
                  ไม่ว่าส่วนใดส่วนหนึ่งของการใช้หรือการเข้าถึงเว็บไซต์;
                </p>
              </li>
              <li>
                <p>
                  (h) ใช้เว็บไซต์ในลักษณะที่เป็นการฝ่าฝืนกฎหมายและข้อบังคับใดๆ
                  ในประเทศไทย
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>2.6&nbsp;เราขอสงวนสิทธิในการ:</p>
            <ul>
              <li>
                <p>
                  (a) ตรวจสอบ คัดกรอง และ/หรือ ควบคุมกิจกรรม
                  เนื้อหาหรือข้อมูลใดๆ ที่เกิดขึ้นบนหรือผ่านเว็บไซต์;
                </p>
              </li>
              <li><p></p></li>
              <li>
                <p>
                  (b) ตรวจสอบการละเมิดข้อกำหนดเหล่านี้และดำเนินการใดๆ
                  ตามความเหมาะสม;
                </p>
              </li>
              <li><p></p></li>
              <li>
                <p>
                  (c) จำกัด
                  การเข้าถึงและการใช้งานเว็บไซต์ของท่านหากท่านฝ่าฝืนรายการที่ระบุไว้ในข้อ
                  2.5 ข้างต้น; และ/หรือ
                </p>
              </li>
              <li><p></p></li>
              <li>
                <p>
                  (ง)
                  รายงานกิจกรรมที่น่าสงสัยที่เกี่ยวกับการกระทำผิดกฎหมายหรือข้อบังคับใดๆ
                  ที่อาจเกิดขึ้น
                  ต่อหน่วยงานที่เกี่ยวข้องและให้ความร่วมมือกับหน่วยงานดังกล่าว
                </p>
              </li>
              <li><p></p></li>
            </ul>
          </li>
        </ul>
        <h2>3. การรับประกันและข้อจำกัดความรับผิด</h2>
        <ul>
          <li>
            <p>
              3.1&nbsp;ผู้ที่จะซื้อควรอ่านและทำความเข้าใจข้อกำหนดและเงื่อนไขของการขายและตรวจสอบรถยนต์ที่แสดงรายการไว้และดำเนินการโดยอ้างอิงจากการค้นหา
              สอบถาม ตรวจสอบและสอบทานยืนยันความแม่นยำและความถูกต้อง
              ของรายการและข้อมูลที่มีอยู่บนเว็บไซต์ด้วยตัวท่านเองก่อนการซื้อ
            </p>
          </li>
          <li>
            <p>
              3.2&nbsp;ผู้ที่จะซื้อควรทราบด้วยว่ารถยนต์ใดๆ
              ที่แสดงรายการว่ามีจำหน่ายในที่นี้อยู่ภายใต้ข้อกำหนดและเงื่อนไขการขาย
              และรถยนต์ใดๆ ข้างต้นอาจถูกถอนออกจากรายการในเว็บไซต์ได้ตลอดเวลา
              โดยทางเว็บไซต์จะใช้ดุลยพินิจแต่เพียงผู้เดียว
              โดยไม่ต้องมีการแจ้งให้ทราบล่วงหน้าและไม่ว่าด้วยเหตุใดก็ตาม
              การตัดสินใจของเว็บไซต์ที่เกี่ยวข้องกับการเสนอขายถือเป็นที่สุดและจะไม่มีการโต้แย้ง
              ทั้งเรา เว็บไซต์และตัวแทนจะไม่รับผิดชอบต่อเนื้อหาในที่นี้
              ไม่ว่าในลักษณะใดๆ ภายใต้สถานการณ์ใดๆ
              รวมไปถึงแต่ไม่จำกัดแค่เพียงการถอนรถยนต์ออกจากการขาย
            </p>
          </li>
          <li>
            <p>
              3.3&nbsp;เราอาจแก้ไขหรือยกเลิกเว็บไซต์หรือบริการหรือคุณสมบัติใดๆ
              ของเว็บไซต์ รวมถึงรายการที่กำหนด
              โดยอาจจะแจ้งหรือไม่แจ้งให้ทราบล่วงหน้าโดยไม่ต้องมีความรับผิดต่อท่าน
              ผู้ใช้รายอื่น หรือบุคคลที่สามไม่ว่าด้วยเหตุผลใดๆ
              ท่านได้เข้าใจและยอมรับว่าไซต์และบริการของไซต์นั้นถูกจัดให้มีขึ้นบนพื้นฐาน
              “ตามที่มีอยู่" คาร์ซัมจะไม่รับผิดชอบต่อความตรงเวลา การลบออก
              การส่งมอบที่ไม่ถูกต้อง
              หรือความล้มเหลวในการเก็บรักษาการสื่อสารของผู้ใช้ใดๆ
            </p>
          </li>
        </ul>
        <h2>4. ข้อมูลส่วนบุคคล</h2>
        <p>
          ประกาศว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลของเรา
          ใช้ควบคุมการใช้ข้อมูลส่วนบุคคลใดๆ ที่ท่านให้กับเราผ่านทางเว็บไซต์
          โดยสำเนาประกาศว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลสามารถเข้าถึงได้ที่เว็บไซต์
        </p>
        <h2>5. ข้อจำกัดความรับผิดชอบ</h2>
        <p>
          เราจะไม่รับผิดชอบต่อความเสียหายใดๆ
          รวมถึงแต่ไม่จำกัดแค่เพียงความเสียหายทางตรง ความเสียหายทางอ้อม
          ความเสียหายพิเศษ ความเสียหายที่เป็นผลสืบเนื่อง ความเสียหายเชิงลงโทษ
          หรือความเสียหายที่เกิดขึ้นโดยบังเอิญ
          หรือความเสียหายที่เกิดจากการสูญเสียการใช้งาน ผลกำไร ข้อมูล
          หรือสิ่งที่จับต้องไม่ได้อื่นๆ ความเสียหายต่อค่าความนิยม (goodwill)
          หรือชื่อเสียง ที่เกิดขึ้นจากหรือเกี่ยวกับการใช้งาน
          การไม่สามารถใช้งานได้ หรือความขัดข้องล้มเหลวของเว็บไซต์
          เราขอปฏิเสธโดยชัดแจ้งถึงข้อความการรับประกันที่แสดงไว้โดยชัดแจ้งและโดยนัย
          ซึ่งรวมถึงโดยไม่จำกัดเพียงความสมบูรณ์หรือความถูกต้องของข้อมูลใดๆ
          ที่จัดไว้ให้หรือทำให้ใช้งานให้กับท่าน
          เราไม่รับประกันว่าเว็บไซต์และสิ่งอำนวยความสะดวกหรือความสามารถที่เกี่ยวข้องไม่ว่าบางส่วนหรือทั้งหมดจะไม่มีการสะดุดหยุดลงหรือไม่มีข้อผิดพลาด
          ไม่รับประกันว่าความบกพร่องดังกล่าวนั้นจะได้รับแก้ไข
          หรือไม่รับประกันว่าอุปกรณ์และซอฟต์แวร์ที่ทำให้เว็บไซต์พร้อมใช้งานนั้นปราศจากไวรัสหรือส่วนประกอบอื่นใดที่เป็นอันตราย
        </p>
        <p></p>
        <h1 class="title">Terms of Use</h1>
        <h2>1. General</h2>
        <p>
          These are the terms of use and services (“Terms”) of Carsome
          (Thailand) Co., Ltd. (Registration No: 0105559096112). The access to
          and use of the services on this website (“the Website”) are subject to
          these Terms. Carsome provides an online automotive platform that
          allows the prospective buyers to research, compare, bid and purchase
          vehicle(s) listed on the Website. By accessing and using the Website,
          you agree to comply with and be bound by these Terms which shall be
          applicable to all Users of the Website. If you are using and accessing
          the Website for and on behalf of a business entity, the term “you” in
          these Terms shall mean the business entity in which you are
          representing in using the Website, unless the context does not permit.
          You are advised to read these Terms carefully as these affect your
          rights and liabilities under applicable laws and regulations in
          Thailand. If you do not agree to these Terms, you should not use the
          Website.
        </p>
        <h2>2. Right to use and restrictions</h2>
        <ul>
          <li>
            <p>
              2.1.&nbsp;You are responsible for the access to and use of the
              Website, including obtaining the necessary data network access,
              even if the access is by another person.
            </p>
          </li>
          <li>
            <p>
              2.2.&nbsp;You are accessing and using the Website at your own
              risk. We shall not be liable for any damage to, or viruses or
              other codes that may affect any hardware or device, software, data
              or other property as a result of your access to and use of the
              Website.
            </p>
          </li>
          <li>
            <p>
              2.3.&nbsp;You may only access the Website using authorised means.
              It is your responsibility to check and ensure that you have
              downloaded and/or updated the correct software for the hardware
              and device for your access to and use of the Website. We do not
              guarantee that the Website, or any part thereof, will function as
              intended on any particular hardware or device. We are not liable
              if you do not have compatible hardware or a compatible device or
              if you have downloaded the wrong version of the software on your
              hardware or device.
            </p>
          </li>
          <li>
            <p>
              2.4.&nbsp;You shall access and use the Website in accordance with
              any instructions for access to and use of the Website which we may
              make from time to time, these Terms and regulations at the time
              being in force in Thailand.
            </p>
          </li>
          <li>
            <p>2.5.&nbsp;You shall not:</p>
            <ul>
              <li>
                <p>
                  (a) impersonate any person or party or falsely declare,
                  distort or misrepresent your affiliation with any person or
                  party in connection with the Website, or express or imply that
                  we endorse any statement you make;
                </p>
              </li>
              <li>
                <p>
                  (b) in any way damage or disrupt the Website and/or the
                  operation of the Website;
                </p>
              </li>
              <li>
                <p>
                  (c) use the Website for any fraudulent, unauthorised or
                  unlawful purpose;
                </p>
              </li>
              <li>
                <p>
                  (d) deliberately and knowingly provide information or content
                  that is false, misleading, inaccurate, illegal, threatening,
                  obscene, hateful, libellous or defamatory;
                </p>
              </li>
              <li>
                <p>
                  (e) use the Website in a manner that may be contrary to our
                  interests and/or the interest of other Users;
                </p>
              </li>
              <li>
                <p>
                  (f) introduce or allow the introduction of computer viruses
                  and/or other computer programming routines such as any
                  viruses, malware, unsolicited e-mails, Trojan horses, trap
                  doors, back doors, worms, time bombs or cancelbots that may
                  damage, detrimentally interfere with, surreptitiously
                  intercept or expropriate any system, data or personal
                  information, relating to or in connection with the Website;
                </p>
              </li>
              <li>
                <p>
                  (g) reproduce, duplicate, copy, sell, resell or otherwise
                  exploit for any commercial purposes, any portion of, use of,
                  or access to the Website;
                </p>
              </li>
              <li>
                <p>
                  (h) use the Website in a manner that is in breach of any laws
                  and regulations in Thailand.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>2.6.&nbsp;We reserve the right to:</p>
            <ul>
              <li>
                <p>
                  (a) check, vet and/or control any activity, content or
                  information occurring on or through the Website;
                </p>
              </li>
              <li>
                <p>
                  (b) investigate any infringement of these Terms and take any
                  appropriate action thereafter;
                </p>
              </li>
              <li>
                <p>
                  (c) restrict your access to and use of the Website if you
                  violate any of the items stated in Clause 2.5 above; and/or
                </p>
              </li>
              <li>
                <p>
                  (d) report any suspicious activity concerning the possible
                  transgression of any applicable law or regulation to the
                  appropriate authorities and to cooperate with such
                  authorities.
                </p>
              </li>
            </ul>
          </li>
        </ul>
        <h2>3. Warranties and Limitation of Liability</h2>
        <ul>
          <li>
            <p>
              3.1.&nbsp;Prospective buyers are advised to read and understand
              the terms and conditions of the sale and to inspect the vehicles
              listed and conduct and rely on their own searches, enquiries,
              investigations and verifications on the accuracy and correctness
              of the particulars and information provided on the Website prior
              to purchasing.
            </p>
          </li>
          <li>
            <p>
              3.2.&nbsp;All prospective buyers should also note that any
              vehicle(s) listed as available for sale herein is subject to terms
              and conditions of sale and that any of the above vehicle(s) may at
              anytime be withdrawn from the listing in the Website absolute
              discretion without any prior notice being given and for any reason
              whatsoever. The decision of the Website in relation to the
              proposed sale is final and shall not subject to challenge. Neither
              shall we, the Website nor its Agents be held liable for the
              contents herein in any manner whatsoever under any circumstances
              including but not limited to withdrawal of vehicle(s) from the
              sale.
            </p>
          </li>
          <li>
            <p>
              3.3.&nbsp;We may modify or discontinue the Website or any of the
              services or features of the Website, including specific listings,
              with or without notice, without liability to you, any other user
              or any third party for any reason. You understand and agree that
              the Site and its services are provided on an "AS AVAILABLE" basis.
              Carsome assumes no responsibility for the timeliness, deletion,
              mis-delivery of or failure to store any user communications.
            </p>
          </li>
        </ul>
        <h2>4. Personal data</h2>
        <p>
          Our Personal Data Protection Notice governs the use of any personal
          information that you provide to us via the Website. A copy of the
          Personal Data Protection Notice can be accessed here at the Website.
        </p>
        <h2>5. Disclaimer</h2>
        <p>
          We shall not be liable for any damages whatsoever, including but
          without limitation to any direct, indirect, special, consequential,
          punitive or incidental damages, or damages for loss of use, profits,
          data or other intangibles, damage to goodwill or reputation, arising
          out of or related to the use, inability to use or failures of the
          Website. We expressly disclaim any express and implied warranties,
          including, without limitation, completeness or accuracy of any
          information provided or made available to you. We do not warrant that
          the Website and any and all of its related facilities or capabilities
          will be free of interruption or error, that defects will be corrected,
          or that the equipment and software that makes the Website available is
          free of viruses or other harmful components.
        </p>
      </div>
    </div>
  </div>
</template>


<style scoped>
.container {
  padding: 24px 16px 16px 16px;
  width: 100%;
  box-sizing: border-box;
}

p {
  margin-top: 8px;
  text-align: start;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
  font-style: normal;
  color: #696c71;
}

h2 {
  text-align: start;
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
  font-style: normal;
  color: #2e2e2e;
  margin-top: 24px;
  font-weight: 700;
}

ul {
  padding-left: 12px;
}

.title {
  padding-top: 40px;
  padding-bottom: 30px;
  font-size: 20px;
  font-family: Roboto;
  color: #000;
}
</style>
